import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { stack } from '@repo/pandacss/styled-system/patterns';
import { CALCULATOR_LABELS } from './constants';

export type BankingCalculatorProps = StructuredContentDocument<{
  calculator?: string;
}>;

// The MUI original used `<Stack spacing={1}>`. This repo's MUI theme scale is non-linear
// (`packages/ui/src/Theme/index.ts:409`: spacing(1) = 4px), so `spacing={1}` is 4px, not 8px.
// Panda's scale is linear (`n` = `n * 4px`), so 4px is '1' here, not '2'.
const wrapperClass = stack({ columnGap: '1', rowGap: '1' });

const textClass = css({ textStyle: 'body' });

export function BankingCalculator({ props: { calculator } }: BankingCalculatorProps) {
  if (!calculator) return null;
  const label = CALCULATOR_LABELS[calculator];
  if (!label) return null;

  return (
    <div className={wrapperClass} data-testid="banking-calculator">
      <p className={textClass}>{label}</p>
      <p className={textClass}>Coming soon.</p>
    </div>
  );
}
